import React from "react";
import "./What_Is_Counselling.css";
import Common_Title from "../../common/common-title/Common_Title";
import { IDS } from "../../../utils/IDS";

const What_Is_Counselling = ({whatcareer}) => {
  return (
    <section className="What_Is_Counselling">
      <div className="container">
        <div className="What_Is_Counselling_div">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              {/* <Common_Title title="What is Career Counselling? " /> */}
              <Common_Title title={whatcareer?.name} />
              <div className="text_div">
                <p className="counselling_text">
                  {/* Career counselling is a structured process where expert
                  counsellors analyze a student’s aptitude, personality, and
                  interests to recommend suitable career streams, courses, and
                  colleges. */}
                  {whatcareer?.description.replace(/<\/?[^>]+(>|$)/g, "")}
                </p>

                <p className="counselling_text">
                  {/* Our approach combines assessment results with professional
                  insights to provide practical and informed guidance. */}
                </p>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-12">
              <div className="counselling_img_div">
                <img
                  src={IDS?.IMG_URL + whatcareer?.image}
                  alt="counselling-img"
                  className="counselling_img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default What_Is_Counselling;
